export class RemoveLocationStateError extends Error {

}
